import Vue from 'vue'
import store from './store/'

import Router from 'vue-router'
import Dashboard from './components/pages/Dashboard.vue'
import Login from './components/pages/Login.vue'
import Websites from './components/pages/Websites.vue'
import Registries from './components/pages/Registries.vue'
import Domains from './components/pages/Domains.vue'
import Account from './components/pages/Account.vue'
import Services from './components/pages/Services.vue'
import Killist from './components/pages/Killist.vue'
import Stunden from './components/pages/Stunden.vue'
import Tickets from './components/pages/Tickets.vue'
import TicketAdd from './components/pages/TicketAdd.vue'

// snip

Vue.use(Router)


const ifAuthenticated = (to, from, next) => {
	let acls = store.state.auth.userdata.acls
	let name = to.path.replace(/^\//,'')
	if(name == '') name = 'dashboard/list'
	// console.log(name + "!")
	if (acls.includes(name)) {
		next()
		return
	}
	console.warn("Not authenticated for " + name + " in ", acls)
	next('/login')
}

export default new Router({
	mode: 'history',

	routes: [
		{
			path: '/',
			name: 'home',
			component: Websites,
			meta: {
				rule: 'isLoggedIn'
			},
			// beforeEnter: ifAuthenticated,
		},
		{
			path: '/dashboard/list',
			name: 'dash',
			component: Dashboard,
			meta: {
				rule: 'isLoggedIn'
			},
			// beforeEnter: ifAuthenticated,
		},
		{
			path: '/websites/list',
			name: 'websites',
			component: Websites,
			meta: {
				rule: 'Websites'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/domains/list',
			name: 'domains',
			component: Domains,
			meta: {
				rule: 'domains'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/killist/list',
			name: 'Killist',
			component: Killist,
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/registries/list',
			name: 'registries',
			component: Registries,
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/domains/list',
			name: 'domains',
			component: Domains,
			meta: {
				rule: 'Domains'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/account/list',
			name: 'account',
			component: Account,
			meta: {
				rule: 'Account'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/services/list',
			name: 'services',
			component: Services,
			meta: {
				rule: 'Services',
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/arbeitsstunden/list',
			name: 'arbeitsstunden',
			component: Stunden,
			meta: {
				rule: 'Arbeitsstunden'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/tickets/list',
			name: 'tickets',
			component: Tickets,
			meta: {
				rule: 'isLoggedIn'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/tickets/add',
			name: 'tickets_add',
			component: TicketAdd,
			meta: {
				rule: 'isLoggedIn'
			},
			beforeEnter: ifAuthenticated,
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			props: true
		}
	]
})
